module.exports = __webpack_public_path__ + "img/mdg-image.78ac1236.png";